import { render, staticRenderFns } from "./medical_left.vue?vue&type=template&id=171f61ee"
import script from "./medical_left.vue?vue&type=script&lang=js"
export * from "./medical_left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports